import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageName } from '../reducers/pageSlice';
import TabFactory from '../components/tabs/TabFactory';
import { tabSlice } from '../reducers/automatedJobs/tabs';
import { fetchDataCollections } from '../reducers/dataCollectionSlice';
const DATA_COLLECTIONS_URL = '/api/dataCollections';

function AutomatedJobs() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageName('Automated Jobs'));
    dispatch(
      fetchDataCollections({
        url: DATA_COLLECTIONS_URL,
        params: null,
        method: 'GET',
      })
    );
  });

  return <TabFactory slice={tabSlice} />;
}

export default AutomatedJobs;
